import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  disconnect() {
    $.rails.handleRemote($(this.element));
  }
}
